import { Button, RemoveIcon } from "melco-ui";
import { Key } from "react";
import { useTranslation } from "react-i18next";
import { useAddRemoveMachine } from "../../../hooks/reporting/useAddRemoveMachine";

export type BulkActionRemoveMachinesProps = {
  selectedRowKeys: Key[];
  setSelectedRowKeys: (keys: Key[]) => void;
};

export const BulkActionRemoveMachines: React.FC<
  BulkActionRemoveMachinesProps
> = ({ selectedRowKeys, setSelectedRowKeys }) => {
  const { removeMachines } = useAddRemoveMachine();

  const { t } = useTranslation();

  const idsToRemove = selectedRowKeys.map((dk) => {
    return {
      device_id: dk as string,
    };
  });

  return (
    <>
      {selectedRowKeys.length > 0 && (
        <Button
          icon={<RemoveIcon />}
          onClick={() => {
            removeMachines(idsToRemove);
            setSelectedRowKeys([]);
          }}
        >
          {t("reporting.machines.remove_selected")}
        </Button>
      )}
    </>
  );
};
